var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-qr',{attrs:{"correctLevel":3,"autoColor":false,"colorDark":_vm.colorDark,"logoSrc":_vm.logoSrc,"logoScale":0.3,"text":_vm.url,"size":_vm.size,"logoMargin":_vm.logoMargin,"margin":0}})}
var staticRenderFns = []

export { render, staticRenderFns }